angular.module("warsApp.directives").directive('focusMe', function () {
    return {
        restrict: 'A',
        scope: {
            focusTrigger: '=focusMe'
        },
        link: function (scope, element) {
            scope.$watch('focusTrigger', function (newValue) {
                if (newValue === true) {
                    element[0].focus();
                    scope.focusTrigger = false;
                }
            });
        }
    };
});